export const MAX_MEMBER_CHIPS_TO_DISPLAY = 3;
export const DEFAULT_CAP_LEVEL_COLOR_GREY = '#666';
export const SESSION_HEALTH_DATA_POLLING_RATE_IN_SECONDS = 30 * 1000;
